export const EMAIL_TEMPLATES_COMMON_QUERY_KEY = "email_templates";

export const EmailTemplatesSidebarQueryKeys = {
  list: [EMAIL_TEMPLATES_COMMON_QUERY_KEY, "email_tempaltes_list"],
  emailHistory: [EMAIL_TEMPLATES_COMMON_QUERY_KEY, "email_history"],
  campaignEmailAutomationCheck: ["campaign_email_automation_check"],
  emailSequence: [EMAIL_TEMPLATES_COMMON_QUERY_KEY, "email_sequence"],
};
